import { render, staticRenderFns } from "./EditBreed.vue?vue&type=template&id=297f01e0&scoped=true&"
import script from "./EditBreed.vue?vue&type=script&lang=js&"
export * from "./EditBreed.vue?vue&type=script&lang=js&"
import style0 from "./EditBreed.vue?vue&type=style&index=0&id=297f01e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f01e0",
  null
  
)

export default component.exports